@if (loading()) {
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
    style="margin: auto"
  ></mat-progress-spinner>
}

@if (!loading()) {
  <form [formGroup]="form">
    <payee-dropzone
      height="taller"
      title="Tölts fel bizonyítékot a jogviszonyhoz"
      description=""
      [multiple]="true"
      (dropped)="legalBaseEvidencesDropped($event)"
    ></payee-dropzone>
    @if (legalRelationshipOcrLoading()) {
      <mat-progress-spinner
        diameter="24"
        mode="indeterminate"
      ></mat-progress-spinner>
    }
    @for (file of files.controls; track file; let i = $index) {
      <div class="flex vcenter evidence-row">
        <div class="evidence-index">{{ i + 1 }}.</div>
        <span class="grow1">{{ file.value.file_name }}</span>
        <button
          payee-mini-icon-button
          type="button"
          color="white"
          (click)="openLegalBaseEvidence(file.value)"
        >
          <payee-icon name="external-link-blue"></payee-icon>
        </button>
        <button
          payee-mini-icon-button
          type="button"
          color="white"
          (click)="removeLegalBaseFile(i)"
        >
          <payee-icon name="trash-red"></payee-icon>
        </button>
      </div>
    }
    <payee-form-field
      width="wide"
      [aiFilled]="isAiFilled(type_id)"
    >
      <span payee-label>Jogviszony típusa</span>
      <payee-autocomplete
        placeholder="Válassz jogviszonyt!"
        [formControl]="type_id"
        [options]="legalRelationshipOptions"
        [displayWith]="legalBaseTypeDisplayWith"
      ></payee-autocomplete>
    </payee-form-field>
    @if (showLegalBaseSpecification) {
      <payee-form-field width="wide">
        <input
          payee-input
          [formControl]="specification"
        />
        <span payee-label>Jogviszony részletezése</span>
      </payee-form-field>
    }
    @if (invoiceItemPreview()) {
      <div class="invoice-item-preview">
        <div class="invoice-item-preview-label">Számla tétel</div>
        <div class="invoice-item-preview-text">{{ invoiceItemPreview() }}</div>
      </div>
    }
  </form>
}
